import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import PadelFinder from "@/pages/PadelFinder";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PadelFinder />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
      {/* Visual effects */}
      <div className="noise-overlay" />
      <div className="scanlines" />
    </div>
  );
}

export default App;
